import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/MANAGE_PLAN_PRICING';

export const {action: convertDiscountOrigin} = createAction(
    `${domain}/CONVERT_DISCOUNT_ORIGIN`,
    (planPartId, discountId, discountOrigin) => ({planPartId, discountId, discountOrigin}),
);

export const {action: updateDiscountPreset} = createAction(
    `${domain}/UPDATE_DISCOUNT_PRESET`,
    (planPartId, preset) => ({planPartId, preset}),
);

export const {action: addDiscount} = createAction(
    `${domain}/ADD_DISCOUNT`,
    (planPartId, addId, preset, isSurcharge) => ({planPartId, addId, preset, isSurcharge}),
);

export const {action: addCustomSurcharge} = createAction(`${domain}/ADD_CUSTOM_SURCHARGE`, () => ({}));

export const {action: removeDiscount} = createAction(`${domain}/REMOVE_DISCOUNT`, (planPartId, discountId) => ({
    planPartId,
    discountId,
}));

export const {action: resetPlanPartTemplate} = createAction(`${domain}/RESET_PLAN_PART_TEMPLATE`, () => ({}));
export const {action: showAddDiscount} = createAction(`${domain}/SHOW_ADD_DISCOUNT`, show => ({show}));

export const {action: addSurcharge} = createAction(`${domain}/ADD_SURCHARGE`, () => ({}));

export const {action: discountDidChange} = createAction(
    `${domain}/DISCOUNT_DID_CHANGE`,
    (planPartId, newDiscount, discountId) => ({planPartId, newDiscount, discountId}),
);

export const {action: convertToPercentage} = createAction(
    `${domain}/CONVERT_TO_PERCENTAGE`,
    (planPartId, newDiscount, discountId) => ({planPartId, newDiscount, discountId}),
);

export const {action: discountFrequencyChanged} = createAction(
    `${domain}/DISCOUNT_FREQUENCY_CHANGED`,
    (planPartId, newDiscountFrequency, discountId) => ({planPartId, newDiscountFrequency, discountId}),
);

export const {action: discountTitleDidChange} = createAction(
    `${domain}/DISCOUNT_TITLE_DID_CHANGE`,
    (planPartId, newTitle, discountId) => ({planPartId, newTitle, discountId}),
);

export const {action: discountShowOnInvoice} = createAction(
    `${domain}/DISCOUNT_SHOW_ON_INVOICE`,
    (planPartId, show, discountId) => ({planPartId, show, discountId}),
);

export const {action: removePublicFunding} = createAction(`${domain}/REMOVE_PUBLIC_FINDING`, () => ({}));
